module.exports = "data:application/octet-stream;base64,LnRoZW1lLWRhcmsgew0KCS5zbGMtY3VzdG9tLWRvdCB7DQoJCWJvcmRlcjogc29saWQgMC41cmVtICMyOTYyZmY7DQoJCWJvcmRlci1yYWRpdXM6IDUwJTsNCgkJd2lkdGg6IDJyZW07DQoJCWhlaWdodDogMnJlbTsNCgkJbWF4LXdpZHRoOiAycmVtOw0KCQltaW4td2lkdGg6IDJyZW07DQoJCS5zbGMtZG90LWNlbnRlciB7DQoJCQlib3JkZXItcmFkaXVzOiA1MCU7DQoJCQl3aWR0aDogMXJlbTsNCgkJCWhlaWdodDogMXJlbTsNCgkJCW1heC13aWR0aDogMXJlbTsNCgkJCW1pbi13aWR0aDogMXJlbTsNCgkJCWJhY2tncm91bmQtY29sb3I6ICNjYmQ5ZmY7DQoJCX0NCgl9DQp9DQo="


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/SimpleLineChart/SimpleLineChartDark.scss
// module id = 2576
// module chunks = 0